<div [ngClass]="{'border border-grayTableBorder rounded p-3': hideExcept === null}"
     [attr.data-field]="field?.fieldUuid"
     [attr.data-typeId]="field?.config?.typeId">

  <div *ngFor="let wrappedItem of control.controls; let i = index;"
       class="repeater-wrapped-item"
       [ngClass]="{'border border-grayTableBorder bg-grayNavi rounded p-3': hideExcept === null}">

    <ng-container *ngIf="field">
      <ng-container *ngIf="hideExcept === null">
        <div class="flex flex-row justify-between items-center">
        <span class="text-md text-black font-bold">
          {{ field.config.texts.item }}<span class="ml-2">#{{ i + 1}}</span>
        </span>

          <button class="btn btn-sm text-gray border-transparent shadow-none hover:text-grayDark fadeInFadeOut"
                  (click)="removeRepeaterItem(i)"
                  type="button"><i class="fas fa-trash-alt"></i>
          </button>
        </div>
      </ng-container>



      <ng-container *ngFor="let subFieldUuid of subFieldsOrder; let i = index">
          <!-- Guard against subFieldsOrder entries that don't have a matching
               subFields record. Previously, a stale repeater config (uuid in
               sub_fields_order but no field row resolved on the BE) would
               throw at `.type` and silently break the whole repeater render,
               so users would see the form load but without the missing
               sub-field (e.g., the required "Tip stroška" dropdown on Stroški
               — BRIEFD-6455 review). Skipping cleanly here keeps the rest of
               the form usable. -->
          <div class="mb-3" [hidden]="hideExcept !== null && wrappedItem !== hideExcept"
               *ngIf="subFieldsForRow(wrappedItem)[subFieldUuid] && subFieldsForRow(wrappedItem)[subFieldUuid].type !== 'currency_conversion_rate'">

            <app-form-input [formGroup]="asFormGroup(asFormGroup(wrappedItem).controls.value)"
                            [field]="subFieldsForRow(wrappedItem)[subFieldUuid]"
                            *ngIf="subFieldsForRow(wrappedItem)[subFieldUuid].type !== 'currency'; else view"></app-form-input>

            <ng-template #view>
              <app-inline-field-edit [cancelEditOnSave]="true" textSize="sm"
                                     [updateField]="false"
                                     [formGroup]="asFormGroup(asFormGroup(wrappedItem).controls.value)"
                                     [field]="subFieldsForRow(wrappedItem)[subFieldUuid]"
                                     [subFields]="subFieldsForRow(wrappedItem)"
                                     [isHiddenRepeaterField]="hideExcept !== null && wrappedItem !== hideExcept"
                                     (update)="fieldsUpdated($event, asFormGroup(wrappedItem))"></app-inline-field-edit>
            </ng-template>
          </div>
      </ng-container>
    </ng-container>
  </div>

  <app-field-errors class="mt-3 block" [control]="control"></app-field-errors>

  <div class="text-right" *ngIf="hideExcept === null">
    <hr class="my-4" *ngIf="control.controls.length > 0">

    <ng-container *ngIf="hasNoWorkOrderItems; else addButton">
      <div class="text-center">
        <a href="/admin/settings/administration/work-order-items" target="_blank"
           class="btn btn-primary btn-sm" i18n>
          <i class="fas fa-cog mr-2"></i>Nastavi opravila <i class="fas fa-external-link-alt ml-1"></i>
        </a>
      </div>
    </ng-container>

    <ng-template #addButton>
      <button class="btn btn-primary btn-sm" (click)="addRepeaterItem()" type="button"><i
              class="fas fa-plus mr-2"></i>{{ field.config.texts.add }}</button>
    </ng-template>
  </div>
</div>


